<form [formGroup]="formGroup" [class]="formClass" (ngSubmit)="onSubmit()">
    <ng-content></ng-content>
</form>